module.exports = __webpack_public_path__ + "static/img/pledge3.24c8792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pledge3.png
// module id = tHaf
// module chunks = 0